import { render, staticRenderFns } from "./JSONTable.vue?vue&type=template&id=616a3569&"
import script from "./JSONTable.vue?vue&type=script&lang=js&"
export * from "./JSONTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports